import { ReactNode } from 'react';
import styled from 'styled-components';

interface Props {
  menuTitle: string;
  children: ReactNode;
  as?: string;
  className?: string;
  id?: string;
}

const Title = styled.span`
  position: absolute;
  top: 0;
  opacity: 0;
  width: 0;
  height: 0;
`;

const Content = styled.div`
  position: relative;
`;

// Use this component when you want to create a sticky navigation menu with a custom title.

const StickyNavMenuTitle = ({ menuTitle, children, as = 'h3', className = '', id = '' }: Props) => (
  <Content as={as} className={className}>
    <Title id={id} aria-hidden="true">
      {menuTitle}
    </Title>
    {children}
  </Content>
);

export default StickyNavMenuTitle;
